<!-- anthor:PuZeHui -->
<template>
  <div class="ele-wrap">
    <div class="wraps">
      <div class="select-box">
        <div class="select-margin">
          <el-select v-model="seachOption.client" placeholder="请选择" @change="seachData" filterable clearable >
            <el-option v-for="item in allCompany" :key="item.value" :label="item.name" :value="item.id" ></el-option>
          </el-select>
        </div>
        <div class="select-margin">
          <el-date-picker
            v-model="seachOption.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy/MM/dd"
            @change="seachData"
          >
          </el-date-picker>
        </div>
        <div class="select-margin">
          <el-select v-model="seachOption.status" placeholder="请选择合同状态" @change="seachData" >
            <el-option v-for="item in stutas" :key="item.value" :label="item.label" :value="item.value" > </el-option>
          </el-select>
        </div>
        <!-- <el-checkbox v-model="dueSoon">即将到期合同</el-checkbox> -->
        <el-button type="primary" @click="dialogFormVisible = true" >新增合同</el-button>
      </div>
      <div class="table-box">
        <el-table border stripe fit
          highlight-current-row
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            label="合同名称"
            prop="name"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="合同编号"
            prop="id"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="服务提供方公司"
            prop="serviceProviderCompanyName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="服务提供方公司办理人"
            prop="serviceProviderTransactorNickname"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="客户公司"
            prop="clientCompanyName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="客户公司办理人"
            prop="clientTransactorNickname"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="合同状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                stutas.find(c => c.value == scope.row.status)["label"]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="签订时间" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.signingTime.substr(0, 11) }}
            </template>
          </el-table-column>
          <el-table-column
            label="开始时间"
            prop="startTime"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.startTime.substr(0, 11) }}
            </template>
          </el-table-column>
          <el-table-column
            label="结束时间"
            prop="endTime"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.endTime.substr(0, 11) }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="operatiing" @click="openDetails(scope.row)"
                >详情</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 详情抽屉 -->
    <el-drawer
      title="详情"
      :visible.sync="detailDrawer"
      direction="rtl"
      :before-close="handleClose"
      size="40%"
    >
      <div class="drawer-main">
        <div class="drawer-header">
          <div class="headbox">
            <span class="title">合同状态</span>
            <span class="satus" v-if="detail">
              {{ stutas.find(c => c.value == detail.status)["label"] }}
            </span>
          </div>
        </div>
        <div class="drawer-cent">
          <div class="title">基本信息</div>
          <div class="detailbox">
            <span class="label">合同名称</span><span>{{ detail.name }}</span>
          </div>
          <div class="detailbox">
            <span class="label">合同编号</span><span>{{ detail.id }}</span>
          </div>
          <div class="detailbox">
            <span class="label">服务提供商公司</span
            ><span>{{ detail.serviceProviderCompanyName }}</span>
          </div>
          <div class="detailbox">
            <span class="label">服务提供办理人</span
            ><span>{{ detail.serviceProviderTransactorNickname }}</span>
          </div>
          <div class="detailbox">
            <span class="label">客户公司</span
            ><span>{{ detail.clientCompanyName }}</span>
          </div>
          <div class="detailbox">
            <span class="label">客户公司办理人</span
            ><span>{{ detail.clientTransactorNickname }}</span>
          </div>
          <div class="detailbox">
            <span class="label">签订时间</span
            ><span>{{ detail.signingTime }}</span>
          </div>
          <div class="detailbox">
            <span class="label">开始时间</span
            ><span>{{ detail.startTime }}</span>
          </div>
          <div class="detailbox">
            <span class="label">结束时间</span><span>{{ detail.endTime }}</span>
          </div>
          <div class="title" style="margin-top:10px">服务内容</div>
          <div class="detailbox" v-for="(item, i) in detail.services" :key="i">
            <span class="label">项目类型</span>
            <span>
              {{ taskList.find(c => c.value == item.type)["label"] }}
            </span>
            <div>
              <p class="label" style="margin-top:15px">测量点</p>
              <span
                v-for="(measures, i) in item.measures"
                :key="i"
                style="margin-right:8px"
              >
                <span v-if="item.measures">
                  {{ measureList.find(c => c.measureId == measures)["measureName"] }}
                </span>
              </span>
            </div>
            <div v-if="item.type == 3 || item.type == 4">
              <p class="label" style="margin-top:15px">周期</p>
              <span>
                {{ cycleList.find(c => c.value == item.cycle)["label"] }}
              </span>
            </div>

            <div v-if="item.type == 3 || item.type == 4">
              <p class="label" style="margin-top:15px">每周期内次数</p>
              <span>
                {{ item.times }}
              </span>
            </div>
            <div v-else>
              <p class="label" style="margin-top:15px">
                最大次数
              </p>
              <span>
                {{ item.times }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="新增合同" :visible.sync="dialogFormVisible">
      <el-form :model="contractForm">
        <div class="title-s">基本信息</div>
        <el-form-item label="合同名称" :label-width="formLabelWidth">
          <el-input v-model="contractForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="签订时间" :label-width="formLabelWidth">
          <el-date-picker
            v-model="contractForm.signingTime"
            type="date"
            value-format="yyyy/MM/dd"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="起止时间" :label-width="formLabelWidth">
          <el-date-picker
            v-model="contractForm.value1"
            type="daterange"
            value-format="yyyy/MM/dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="服务提供方公司" :label-width="formLabelWidth">
          <el-select
            v-model="contractForm.serviceProviderCompanyId"
            placeholder="请选择服务提供方公司"
            @change="changeCompany"
            filterable
          >
            <el-option
              v-for="(item, i) in allCompany"
              :key="i"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务提供方办理人" :label-width="formLabelWidth">
          <el-select
            v-model="contractForm.serviceProviderTransactorId"
            placeholder="请选择服务提供方办理人"
            filterable
          >
            <el-option
              v-for="(item, i) in serversList"
              :key="i"
              :label="item.nickname"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户公司" :label-width="formLabelWidth">
          <el-select
            v-model="contractForm.clientCompanyId"
            placeholder="请选择客户公司"
            @change="changeClient"
            filterable
          >
            <el-option
              v-for="(item, i) in allCompany"
              :key="i"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户公司办理人" :label-width="formLabelWidth">
          <el-select
            v-model="contractForm.clientTransactorId"
            placeholder="请选择客户公司办理人"
            filterable
          >
            <el-option
              v-for="(item, i) in clientServersList"
              :key="i"
              :label="item.nickname"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="title-s">服务内容</div>
        <el-form-item
          label="项目类型"
          :label-width="formLabelWidth"
          v-for="(item, i) in contractForm.services"
          :key="i"
        >
          <el-select
            v-model="item.type"
            placeholder="请选择项目类型"
            @change="changeType"
          >
            <el-option
              v-for="(item, i) in taskList"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div class="ts">
            <p v-if="item.type != 5 && item.type != ''">添加测量点:</p>
            <el-input
              v-if="item.type != 5 && item.type != ''"
              v-model="item.params.measures"
              placeholder="请输入添加测量点"
            ></el-input>
            <!-- <el-checkbox-group
              v-model="item.params.measures"
              v-if="item.type != 5 && item.type != ''"
            >
              <span style="display:inline-block;margin-right:5px">
                <el-checkbox
                  :label="item.id"
                  v-for="(item, i) in measureList"
                  :key="i"
                  >{{ item.measureName }}</el-checkbox
                >
              </span>
            </el-checkbox-group> -->
            <p v-if="item.type == 3 || item.type == 4 || item.type == 7">
              周期:
            </p>
            <el-select
              v-model="item.params.cycle"
              placeholder="请选择周期"
              v-if="item.type == 3 || item.type == 4 || item.type == 7"
            >
              <el-option
                v-for="(item, i) in cycleList"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <p v-if="item.type == 1 || item.type == 2">
              最大次数:
            </p>
            <el-input
              v-if="item.type == 1 || item.type == 2"
              type="number"
              v-model="item.params.times"
              placeholder="请输入最大次数"
            ></el-input>
            <p v-if="item.type == 3 || item.type == 4">
              每周期内次数:
            </p>
            <el-input
              v-if="item.type == 3 || item.type == 4"
              type="number"
              v-model="item.params.times"
              placeholder="请输入每周期内次数"
            ></el-input>
          </div>
          <div style="text-align:left">
            <el-button size="mini" type="primary" @click="deletePlan(i)"
              >删除项目类型</el-button
            >
          </div>
        </el-form-item>
        <div style="text-align: right;">
          <el-button size="mini" type="primary" @click="addTaskType"
            >添加项目类型</el-button
          >
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import contractHttpSet from "./httpClass";
export default {
  components: {},
  data() {
    return {
      detail: "",
      cycleList: [
        { label: "无", value: 0 },
        { label: "周(1/4月)", value: 1 },
        { label: "月(1月)", value: 2 },
        { label: "季度(3月)", value: 3 },
        { label: "半年(6月)", value: 4 },
        { label: "年(12月)", value: 5 }
      ],
      measureList: [],
      serversList: [],
      clientServersList: [],
      contractHttpSet: "",
      allCompany: "",
      stutas: [
        { label: "全部状态", value: -1 },
        { label: "生效中", value: 1 },
        { label: "正常终止", value: 2 },
        { label: "协商终止", value: 3 }
      ],
      taskList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 }
      ],
      contractForm: {
        name: "",
        signingTime: "",
        startTime: "",
        endTime: "",
        serviceProviderCompanyId: "",
        serviceProviderTransactorId: "",
        clientCompanyId: "",
        clientTransactorId: "",
        services: [{ type: "", params: { measures: [], cycle: "", times: "" } }]
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      detailDrawer: false,
      seachOption: {
        client: "",
        status: -1,
        time: []
      },

      clientList: [{ label: "全部客户", value: 0 }],
      tableData: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    deletePlan(i) {
      this.contractForm.services.splice(i, 1);
    },
    async seachData() {
      const client = this.seachOption.client === "" ? [] : [this.seachOption.client];
      this.tableData = await this.contractHttpSet.getListElectricOperationsContractForServiceProvider(
        0,
        client,
        this.seachOption.time[0],
        this.seachOption.time[1],
        this.seachOption.status
      );
      console.log(this.tableData);
    },
    async saveData() {
      // 20210910

      if (this.contractForm.services.length > 0) {
        this.contractForm.services = this.contractForm.services.map(item => {
          if (item.params.measures.length > 0) {
            item.params.measures = item.params.measures.split(",");
          }
          return {
            ...item
          };
        });
      }
      // end
      console.log(this.contractForm.value1);
      if (this.contractForm.value1) {
        this.contractForm.startTime = this.contractForm.value1[0];
        this.contractForm.endTime = this.contractForm.value1[1];
      }

      let res = await this.contractHttpSet.addElectricOperationsContract(
        this.contractForm.name,
        this.contractForm.signingTime,
        this.contractForm.startTime,
        this.contractForm.endTime,
        this.contractForm.serviceProviderCompanyId,
        this.contractForm.serviceProviderTransactorId,
        this.contractForm.clientCompanyId,
        this.contractForm.clientTransactorId,
        this.contractForm.services
      );
      if (res.success && res.errorCode == 0) {
        this.dialogFormVisible = false;
        this.initData();
        this.$message.success("添加成功");
        this.tableData = await this.contractHttpSet.getListElectricOperationsContractForServiceProvider();
      }
    },
    initData() {
      this.contractForm = {
        name: "",
        signingTime: "",
        startTime: "",
        endTime: "",
        serviceProviderCompanyId: "",
        serviceProviderTransactorId: "",
        clientCompanyId: "",
        clientTransactorId: "",
        services: [{ type: "", params: { measures: [], cycle: "", times: "" } }]
      };
    },
    addTaskType() {
      this.contractForm.services.push({
        type: "",
        params: { measures: [], cycle: "", times: "" }
      });
    },
    changeType(i) {
      console.log(i);
    },
    handleClose(done) {
      done();
    },
    openDetails(detail) {
      this.detailDrawer = true;
      this.detail = detail;
      // this.detail.services.forEach(item => {
      //   console.log(item)
      //   item.params = JSON.parse(item.params);
      // });
      this.detail.services = this.detail.services.map(item => {
        const params = JSON.parse(item.params);
        return {
          ...item,
          ...params
        };
      });
      let measureList = [];
      this.detail.services.forEach(item => {
        measureList = measureList.concat(item.measures);
      });
      this.$api.electricOperations.getOperationsMeasureInfo(this.detail.clientCompanyId, -1).then(res => {
        if (res.success) {
          this.measureList = res.data
        }
      });
      console.log("detail", this.detail);

      // this.detail.params = JSON.parse(this.detail.params);
    },
    async changeCompany(id) {
      if (id == this.contractForm.clientCompanyId) {
        this.contractForm.serviceProviderCompanyId = "";
        this.$message.error("不能与客户公司重复");
        return;
      }

      this.serversList = await this.contractHttpSet.getListAllUserByCompany(id);
      this.contractForm.serviceProviderTransactorId = "";
    },
    async changeClient(id) {
      if (id == this.contractForm.serviceProviderCompanyId) {
        this.contractForm.clientCompanyId = "";
        this.$message.error("不能与服务提供方公司重复");
        return;
      }
      this.clientServersList = await this.contractHttpSet.getListAllUserByCompany(
        id
      );
      this.contractForm.clientTransactorId = "";
    }
  },
  async created() {
    this.contractHttpSet = new contractHttpSet(this);
    this.tableData = await this.contractHttpSet.getListElectricOperationsContractForServiceProvider();
    // 获取所有公司
    this.allCompany = await this.contractHttpSet.getListAllCompany();
    //获取公司维保客户
    this.clientList = await this.contractHttpSet.getListClientsForElectricOperationsCompany();
    //获取测量点
    this.measureList = await this.contractHttpSet.getcompanyFrontEndPageDefaultParam();
    console.log(this.tableData);
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
};
</script>
<style lang="scss" scoped>
.ele-wrap {
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  .wraps {
    width: 100%;
    height: 100%;
    background: #fff;
    padding: 14px;
    box-sizing: border-box;
  }
  .select-box {
    display: flex;
    align-items: center;
    .select-margin {
      margin-right: 10px;
    }
  }
  .table-box {
    margin-top: 30px;
  }
}

.drawer-main {
  color: #333;
  padding: 20px 30px 30px 30px;
  .drawer-header {
    display: flex;
    margin-bottom: 40px;
    .headbox {
      color: #999999;
      margin-right: 10px;
      .title {
        margin-right: 10px;
      }
      .satus {
        display: inline-block;
        padding: 8px;
        background: #f7eee9;
        border-radius: 4px;
        color: #fda32b;
      }
      .month {
        font-size: 24px;
        color: #333;
      }
    }
  }
  .drawer-cent {
    div {
      text-align: left;
    }
    .title {
      font-size: 18px;
    }
    .detailbox {
      margin-top: 15px;
      .label {
        color: #999999;
        display: inline-block;
        width: 100px;
        text-align: right;
        margin-right: 12px;
      }
    }
  }
}
.title-s {
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}
::v-deep .el-input input {
  height: 30px;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-input__inner {
  height: 30px;
  width: 100%;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: 25px;
}
::v-deep .el-date-editor .el-range__icon {
  line-height: 25px;
}
::v-deep th {
  background: #ecf1f8;
}
::v-deep .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
::v-deep .el-date-editor .el-range__close-icon {
  line-height: 25px;
}
.operatiing {
  color: cornflowerblue;
  cursor: pointer;
}
.ts {
  text-align: left;
  line-height: 25px;
  width: 100%;
}
</style>
